<div [formGroup]="formGroup || defaultForm" *ngIf="!withMentions" class="{{ customContainerClass }}">
  <textarea
    #textAreaInput
    class="focus:tw-ring-0 focus-visible:tw-border-2 tw-rounded-xl focus:tw-border-border-main tw-w-full tw-border-border-light-gray {{
      inputClass
    }}"
    [placeholder]="placeholder"
    [formControlName]="keyControl || 'defaultControl'"
    [readonly]="isReadonly"
    [rows]="rows"
    [attr.maxLength]="maxLength ? maxLength : null"
    >{{ value }}</textarea
  >
</div>

<div [formGroup]="formGroup" *ngIf="withMentions" class="{{ customContainerClass }} tw-relative">
  <textarea
    #textAreaInput
    class="focus-visible:tw-border-2 focus:tw-ring-0 tw-rounded-xl focus:tw-border-border-main tw-w-full tw-border-border-light-gray {{
      inputClass
    }}"
    [placeholder]="placeholder"
    [formControlName]="keyControl"
    [rows]="rows"
    [attr.maxLength]="maxLength ? maxLength : null"
    (input)="formatContent($event)"
  ></textarea>

  <ngx-mentions
    [textInputElement]="textAreaInput"
    [menuTemplate]="menuTemplate"
    [mentionsConfig]="ngxMentionsConfig"
    (search)="onMentionSearch($event)"
    (selectedChoicesChange)="onSelectedChoicesChange($event)"
  ></ngx-mentions>

  <ng-template #menuTemplate let-selectChoice="selectChoice">
    <ul class="mentions-dropdown tw-absolute tw-bg-white tw-border tw-border-gray-300 tw-rounded tw-shadow-lg tw-max-h-48 tw-overflow-auto tw-z-50 tw-list-none tw-p-0 tw-m-0" 
        *ngIf="filteredMentions.length > 0">
      <li *ngFor="let user of filteredMentions"
          class="tw-px-3 tw-py-2 tw-cursor-pointer hover:tw-bg-gray-100"
          (click)="selectMentionFromMenu(user, selectChoice)">
        <span>{{ user.label }}</span>
      </li>
    </ul>
  </ng-template>
</div>
